import React from 'react';

import WrappedSignInForm from 'components/HomePage/SignInForm';
import authPageBg from 'assets/auth-page-bg.jpg';
import Text from 'ui/Text';
import PageTitle from 'shared/PageTitle';
import { FormattedMessage } from 'react-intl';

const DataPolicy = () => {
  return (
    <div className="data-protection inner-content text-center">
      <PageTitle title="Data Protection Policy" />
      <Text type="heading" modifiers="uppercase medium explainer-title primary-blue">
        <FormattedMessage
          id="DataProtection.Title"
          defaultMessage="EPIC-Africa Data Protection Policy"
        />
      </Text>
      {/* <ol className="data-protection-list">
        <li className="data-protection-list__item">Intro to this policy </li>
        <li className="data-protection-list__item">Terms In this Privacy Policy:	</li>
        <li className="data-protection-list__item">What personal information does EPIC-Africa collect and why?	</li>
        <li className="data-protection-list__item">How EPIC-Africa Uses Information	</li>
        <li className="data-protection-list__item">When EPIC-Africa Discloses Information	</li>
        <li className="data-protection-list__item">Your Choices	</li>
        <li className="data-protection-list__item">Third Party Websites	</li>
        <li className="data-protection-list__item">Data Security and Potential Breach	</li>
        <li className="data-protection-list__item">Cross-Border Movement of Data	</li>
        <li className="data-protection-list__item">Access and Correction	</li>
        <li className="data-protection-list__item">Complaints handling	</li>
        <li className="data-protection-list__item">Changes and Updates to this Privacy Policy	</li>
        <li className="data-protection-list__item">Contact Information	</li>
        <li className="data-protection-list__item">Put this info into a Standard Operating Procedure, internal memo:	</li>
      </ol> */}
      <ol className="data-protection-content inner-content">
        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="Intro to this policy" />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                EPIC-Africa takes its responsibilities with regard to the storage and handling of
                personal information very seriously. This Privacy Policy sets out how we manage
                those responsibilities. This Policy is consistent with the data privacy principles
                found in the guidelines implementing the African Union Convention on Cyber Security
                and Personal Data Protection.
              </p>
              <p>
                This website is managed by EPIC-Africa and all provisions governing your use of this
                website are subject to the terms of this Privacy Policy.
              </p>
              <p>
                Please read this Privacy Policy carefully, as it describes what information we
                gather from you, and how we may use and disclose that information. By registering a
                user account and/or by accessing or using this website, you expressly consent to the
                information handling practices described in this Privacy Policy.
              </p>
              <p>
                EPIC-Africa respects people's privacy. EPIC-Africa is bound by this Policy as well
                as other applicable laws protecting privacy in the countries in which it operates.
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DPP.Title" defaultMessage="Terms In this Privacy Policy" />
          </Text>
          <Text type="explanation" modifiers="explanation">
            <div>
              <p>
                EPIC-Africa means the non-governmental organization registered in the United States
                as EPIC-Africa Foundation. The organization works at the Pan-African level and is
                located at Liberty extension 6, Lot No. 46, Cité de jeune, Cadre Lebou, BP 45581
                Dakar Fann, Senegal; and
              </p>
              <p>
                Personal information or Personal data means information that can be used to identify
                an individual person (such as a name, email address, postal mailing address,
                home/mobile telephone number, etc.).
              </p>
              <p>What personal information does EPIC-Africa collect and why?</p>
              <ol className="dpp-personal-info">
                <li>
                  User-Provided Information: You may provide personal information to EPIC-Africa
                  while using this website, such as when you register, when you submit an
                  application to participate in the EPIC-Africa CSO Excellence Awards, and/or when
                  you provide information in order to compete to receive any award.
                </li>
                <li>
                  "Cookies" Information: When you use this website, we may send one or more cookies
                  – small text files containing a string of alphanumeric characters – to your
                  computer. EPIC-Africa may use both session cookies and persistent cookies. A
                  session cookie disappears after you close your browser. A persistent cookie
                  remains after you close your browser and may be used by your browser on subsequent
                  visits to this website. Persistent cookies can be removed. Please review your web
                  browser "Help" file to learn about the proper way to modify your cookie settings.
                  Please note that if you delete or choose not to accept cookies from this website,
                  you may not be able to utilize the features of this website to their fullest
                  potential.
                </li>
                <li>
                  "Flash Cookies" Information: Flash and other browser plugin applications use
                  technology similar to cookies to enable the storage and recall of settings,
                  preferences and usage data, and other information. Because they are stored in
                  separate software applications, these types of cookies are not managed through
                  your web browser's cookie management interface. EPIC-Africa may employ such
                  techniques, including Adobe Flash Cookies (also called "Local Shared Objects") to
                  track information related to your interaction with features of this website
                  through which Flash-based content is provided. You can access various Flash Cookie
                  management tools and configure certain privacy and security settings for your
                  Flash Player from Adobe's website directly.
                </li>
                <li>
                  "Automatically Collected" Information: When you use this website or open one of
                  our HTML emails, we may automatically record certain information from your web
                  browser by using different types of technology, including "clear gifs" or "web
                  beacons." This "Automatically Collected" information may include Internet Protocol
                  address ("IP Address") or other device address or ID, web browser and/or device
                  type, the web pages or sites that you visit just before or just after this
                  website, the pages you view on this website, and the dates and times that you
                  visit this website.
                </li>
                <li>
                  Linked Website Information: If you link an account you have on a third party
                  service (such as any third party social networking site) to your account on this
                  website, EPIC-Africa may store the access credentials you have provided to that
                  third party service. In addition, EPIC-Africa will have access to and may collect
                  any information you have stored in connection with that third party account that
                  you have configured and those third party services to make available, including
                  personally identifiable information and friends lists. By linking your accounts in
                  this manner, you are authorizing EPIC-Africa as your agent to access and use your
                  account on the third party service in connection with your use of this EPIC-Africa
                  website.
                </li>
                <li>
                  Third Party Web Beacons: We may also implement, on this website, third party
                  content that uses "clear gifs," "web beacons," or other similar techniques, which
                  allow the third party content provider to read and write cookies (including Flash
                  Cookies) to your browser, or which allow the third party to implement similar
                  tracking mechanisms, in connection with your viewing of that third party content
                  displayed on this website. This information is collected directly by the third
                  party, and EPIC-Africa does not participate in that data transmission. Information
                  collected by third parties in this manner is subject to that third party's own
                  data collection, use, and disclosure policies.
                </li>
                <li>
                  Information from Other Sources: We may also obtain information, including
                  personally identifiable information, from third parties and sources other than
                  this website, such as other users who import your email address. We may also
                  receive information from third party services that provide a mechanism to expose
                  information you have provided to such third party through the use of an
                  application program interface (API), such as Facebook Connect and the Google API.
                  We may also gather information from publicly available sources, directories,
                  libraries, and publically accessible website. If we combine or associate
                  information from other sources with personally identifiable information that we
                  collect through this website, we will treat the combined information as personally
                  identifiable information in accordance with this Privacy Policy.
                </li>
              </ol>
              <p>
                Data: all information that is collected, stored and shared about our staff, the
                projects and people we work with, and data provided to us about the community by
                other philanthropic organizations.
              </p>
              <p>
                Data that is deemed sensitive: information that is protected against unwarranted
                disclosure due to personal, ethical, legal or other reasons.
              </p>
              <p>
                Consent: Informed consent ensures that people can provide data or participate freely
                and voluntarily, with full information about what it means for them to take part.
                Consent must be given before people start to provide their data.
              </p>
              <p>
                Use of data: the collection, storage, sharing, and publishing of data that occurs
                while we support open technologies and contribute to the broader IF community.
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="How EPIC-Africa Uses Information" />
          </Text>
          <Text type="explanation">
            <div>
              <p>EPIC-Africa will use the information that your organization provides to:</p>
              <ol className="disk">
                <li>Determine the winners of the African CSO Excellence Awards; </li>
                <li>
                  Determine and highlight the top 10 CSOs in each of EPIC-Africa’s assessment
                  categories;
                </li>
                <li>Build knowledge about African CSOs;</li>
                <li>Make it easier for donors to find your organization; and</li>
                <li>Make it easier for your organization to find and connect with other CSOs.</li>
              </ol>
              <p>
                EPIC-Africa also uses the information that you provide or that we collect to
                operate, maintain, enhance, and provide all of the features and services found on
                this website. We will use your email address to contact you with respect to your
                submittals, applications for any award, and for other purposes related to our awards
                and competitions, for administrative and customer service purposes, to address
                intellectual property infringement, rights of privacy, or defamation issues, or
                regarding Postings.
              </p>
              <p>
                EPIC-Africa also uses the information that you provide or that we collect to
                understand and analyze the usage trends and preferences of our users, to improve the
                way this website works and looks, and to create new features and functionality.
              </p>
              <p>
                EPIC-Africa may use "Automatically Collected" information and "cookies" information
                to:
              </p>
              <ol className="disk">
                <li>
                  Personalize our services, such as remembering your information so that you will
                  not have to re-enter it during your visit or the next time you visit this website;
                </li>
                <li>Provide customized third party content and information; </li>
                <li>
                  Monitor and analyze the operation and effectiveness of this website and related
                  activities;{' '}
                </li>
                <li>
                  Monitor aggregate site usage metrics such as total number of visitors and pages
                  viewed; and
                </li>
                <li>Track your status in competitions or other activities.</li>
              </ol>
              <p>
                EPIC-Africa may use your email address or other personally identifiable information
                to send you:
              </p>
              <ol className="disk">
                <li>Messages about this website or communications from other users; </li>
                <li>
                  Promotional messages related to this website and the activities of third parties
                  with whom we work; and
                </li>
                <li>
                  Messages on behalf of other users, who think that you may be interested in this
                  website. You will have the ability to opt-out of receiving communications from
                  other members, either through links provided in the messages, or by updating your
                  account settings through this website.
                </li>
              </ol>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage
              id="DP.Title"
              defaultMessage="When EPIC-Africa Discloses Information"
            />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                We are not in the business of selling your information. We do, however, disclose
                your personally identifiable information in a variety of circumstances in connection
                with developing and maintaining this website and operating or supporting our
                competitions and other services. For example:
              </p>
              <p>
                <ol className="block">
                  <li>
                    By its nature, this website enables users to communicate in a variety of ways.
                    This also applies to information you choose to make available through features
                    that connect to third party services, if applicable. Once you make your
                    personally identifiable information available to other users or to third party
                    services through the EPIC-Africa website, that information may be collected and
                    used by those recipients without restriction. We urge users to exercise common
                    sense, prudence and good judgment about what personal information you choose to
                    make available to others through the EPIC-Africa Website.
                  </li>
                  <li>
                    When you register or create an account on the EPIC-Africa website, EPIC-Africa
                    may disclose your personally identifiable information to any sponsor or funder
                    of any Competition in which you participate, and/or to other applicants and
                    registrants, in order to increase your access to potential partners and funders.
                  </li>
                  <li>
                    EPIC-Africa works with third party service providers to provide general website
                    hosting, specialized content hosting (e.g. the hosting of video content),
                    maintenance, and other services. These third parties may have access to or
                    process your personally identifiable information as a result of performing the
                    services they were engaged to perform.
                  </li>
                  <li>
                    EPIC-Africa may also disclose your information if required to do so by law or in
                    the good-faith belief that such action is necessary or useful to comply with
                    applicable laws, to respond to a court order, judicial or other government
                    subpoena or warrant, or to otherwise assist or cooperate with law enforcement
                    activity or other similar activities in connection with internal or coordinated
                    fraud detection and prevention, and the protection or enforcement of third party
                    legal rights.
                  </li>
                  <li>
                    EPIC-Africa works to promote a safe and reliable service for all users. We
                    reserve the right to disclose your information when we believe, in good faith,
                    that such disclosure is appropriate or necessary to take precautions against
                    liability; to protect EPIC-Africa and others from fraudulent, abusive,
                    predatory, or unlawful uses or activity; to investigate and/or defend ourselves
                    against any third party claims or allegations; to protect the security or
                    integrity of this website; or to protect or vindicate the rights, property, or
                    personal safety of EPIC-Africa, our users, or others.
                  </li>
                  <li>
                    EPIC-Africa may disclose personal information if an individual to whom the
                    personal information relates has consented to the disclosure.{' '}
                  </li>
                  <li>
                    <p>
                      EPIC-Africa may disclose personal information to its suppliers, service
                      providers, professional advisers and agents, as necessary to enable those
                      entities to provide relevant services to EPIC-Africa. The types of service
                      providers EPIC-Africa may disclose personal information to include, but are
                      not limited to:
                    </p>
                    <ol className="disk" style={{ textIndent: '3rem' }}>
                      <li>Professional advisors such as lawyers, accountants and auditors;</li>
                      <li>Providers of systems for recruitment management; </li>
                      <li>Data storage providers; and</li>
                      <li>
                        Anyone to whom EPIC-Africa's assets or business (or any part of it) is
                        transferred.
                      </li>
                    </ol>
                  </li>
                  <li>
                    As part of the publication of the results of the competition for the EPIC-Africa
                    CSO Excellence Awards, EPIC-Africa will make publicly available information
                    regarding each CSO that participated in the competition, including: 
                  </li>
                  <ol className="disk">
                    <li>Name of the organization;</li>
                    <li>Organization's contact information;</li>
                    <li>Type of organization;</li>
                    <li>Focus areas;</li>
                    <li>Organization’s Sustainable Development Goals (SDGs)</li>
                    <li>Country or countries in which the CSO is located and operates; </li>
                    <li>Website link for the organization; and</li>
                    <li>Other information relevant to the mission of EPIC-Africa. </li>
                  </ol>
                </ol>
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="How Long Do We Keep Personal Data?" />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                We ensure that personal data is retained only for as long as necessary in accordance
                with the above purposes and applicable laws. We may be required to retain your
                personal data for a number of years in order to satisfy legal or contractual
                obligations, or in order to establish, exercise or defend legal claims. When your
                personal data is no longer necessary for these purposes, the personal data will be
                deleted.
              </p>
              <p>
                Cookies Policy: We use cookies, small files which we put on your computer, to
                administer content for visitors to our site. We do not use cookies to track
                individuals and identify them personally.
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="Your Choices " />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                You may, of course, decline to share certain personally identifiable information
                with EPIC-Africa, in which case EPIC-Africa may not be able to provide to you some
                of the features and functionality found on this website. Please note that we may
                retain all information you submit for a variety of purposes, including backups and
                archiving, prevention of fraud and abuse, and analytics.
              </p>
              <p>
                To protect your privacy and security, we take reasonable steps to verify your
                identity before granting you account access or making corrections to your
                information.
                <p className="upper">
                  YOU ARE RESPONSIBLE FOR MAINTAINING THE SECRECY OF YOUR UNIQUE PASSWORD AND
                  ACCOUNT INFORMATION AT ALL TIMES.
                </p>
              </p>
              <p>
                We may now or in the future make certain tools and features for configuring your
                privacy settings available to you through this website. However, any such features
                and settings we may provide do not guarantee the anonymity or confidentiality of any
                information, including personally identifiable information and Postings you provide
                or submit to this website. This is because, while EPIC-Africa implements a number of
                physical and electronic measures to protect personal information, such as
                restricting access to our physical and electronic databases, maintaining firewalls
                and encrypting certain data where practicable to do so, the internet is not a secure
                environment. Therefore, although all care is taken, EPIC-Africa cannot guarantee the
                absolute security of information provided to it via electronic means.
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="Third Party Websites " />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                This website contains links to websites and services provided by third parties. Any
                personally identifiable information you provide on third party sites or services is
                provided directly to that third party and is subject to that third party's policies,
                if any, governing privacy and security. We are not responsible for the content or
                privacy and security practices and policies of third party sites or services to
                which links are displayed on this website. We encourage you to learn about third
                parties' privacy and security policies before providing them with personally
                identifiable information.
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="Data Security and Potential Breach  " />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                EPIC-Africa uses a variety of physical, managerial, and technical safeguards
                designed to improve the security of our systems and safeguard your personally
                identifiable information. We cannot, however, ensure or warrant the security of any
                information you transmit to EPIC-Africa, nor can we guarantee that such information
                may not be accessed, disclosed, altered, or destroyed by breach of any of our
                physical, technical, or managerial safeguards. You transfer your information to
                EPIC-Africa at your own risk.
              </p>
              <p>
                If EPIC-Africa learns of a security systems breach, then we will attempt to notify
                you electronically so that you can take appropriate protective steps. Depending on
                where you live, you may have a legal right to receive notice of a security breach in
                writing. If you'd like to receive such a notice, please notify us at the email
                address provided in the Contact Information section below.
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="Cross-Border Movement of Data   " />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                Your information may be stored and processed in any country in which EPIC-Africa and
                its affiliates maintain facilities. In this regard, or for purposes of sharing or
                disclosing data in accordance with this Privacy Policy, EPIC-Africa reserves the
                right to transfer, store, and process your information outside of your country. Your
                acceptance of the Terms includes your consent to any such transfer, storage, and
                processing of your information outside of your country. EPIC-Africa will take
                reasonable steps to ensure that any overseas recipient will deal with such personal
                information in a way that is consistent with this Privacy Policy.
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="Access and Correction  " />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                An individual has a right to access and request correction to most personal
                information that EPIC-Africa has about that individual. In some circumstances it may
                not be possible for EPIC-Africa to provide the individual with all of his or her
                personal information or a legal exemption may apply. Two examples are that most
                jurisdictions exempt employee records from disclosure requirements, and that
                EPIC-Africa is not required to provide an individual access to information if
                disclosing that information would impact on the privacy of another individual. Where
                EPIC-Africa will not provide access to personal information held about an
                individual, EPIC-Africa will tell the individual why.
              </p>
              <p>
                When an individual requests access to personal information, EPIC-Africa may need to
                take measures to verify the individual's identity before providing them with such
                information. If an individual thinks that any personal information EPIC-Africa holds
                about him or her is inaccurate, the individual may contact the EPIC-Africa Privacy
                Officer using the contact details below and EPIC-Africa will take reasonable steps
                to ensure that the information is corrected.
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="Complaints handling   " />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                If an individual wishes to make a complaint about the way EPIC-Africa has handled
                his or her personal information the individual may do so by contacting the
                EPIC-Africa at admin@epic-africa.org in writing, by mail or email to the address or
                email address set out at the end of this Privacy Policy.
              </p>
            </div>
          </Text>
        </li>

        <li className="data-protection-content-list__item">
          <Text type="normal-semi-bold" modifiers="normal__larger question">
            <FormattedMessage id="DP.Title" defaultMessage="Complaints handling   " />
          </Text>
          <Text type="explanation">
            <div>
              <p>
                If an individual wishes to make a complaint about the way EPIC-Africa has handled
                his or her personal information the individual may do so by contacting the
                EPIC-Africa at admin@epic-africa.org in writing, by mail or email to the address or
                email address set out at the end of this Privacy Policy.
              </p>
            </div>
          </Text>
        </li>
      </ol>
    </div>
  );
};

export default DataPolicy;



// WEBPACK FOOTER //
// ./src/components/HomePage/DataPolicy.js